import { Suspense, useEffect } from "react"
import { Outlet } from "react-router-dom"
import { useGlobal } from "@/app/store/global.ts"
import { useFetchMe } from "@/features/auth/api/use-fetch-me.ts"
import { useAuthStore } from "@/features/auth/model/store.ts"
import { Layout, Spinner } from "@/shared/components"
import { useNavigateIfNotAuthorized } from "@/shared/hooks/use-navigate-if-not-authorized.tsx"
import { ErrorBoundary } from "./errorBoundary.tsx"

export const DashboardGuard = () => {
  // Store
  const { setMe } = useAuthStore()

  // Queries
  const { data } = useFetchMe()

  // Effects
  useEffect(() => {
    if (data) {
      setMe(data)
      useGlobal.setState(() => ({ me: data, loadingTranslations: true, loading: true }))
    }
  }, [data])

  useNavigateIfNotAuthorized()

  return (
    <ErrorBoundary>
      <Layout>
        <Suspense fallback={<Spinner className="!bg-background" />}>
          <Outlet />
        </Suspense>
      </Layout>
    </ErrorBoundary>
  )
}
